var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopAlarmBipTelephonePortrait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 117.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 877",
    d: "M43.082 5.787H27.043a2.067 2.067 0 1 0 0 4.134h16.039a2.067 2.067 0 1 0 0-4.134Z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 192",
    cx: 2.034,
    cy: 2.034,
    r: 2.034,
    transform: "translate(18.814 5.821)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 878",
    d: "M54.736 0H7.264A7.275 7.275 0 0 0 0 7.264V110.5a7.275 7.275 0 0 0 7.264 7.264h47.471A7.275 7.275 0 0 0 62 110.5V7.264A7.275 7.275 0 0 0 54.736 0Zm3.041 110.485a3.05 3.05 0 0 1-3.041 3.041H7.264a3.05 3.05 0 0 1-3.041-3.041V99.149h53.553Zm0-15.559H4.223V16.488h53.553Zm0-82.661H4.223v-5a3.05 3.05 0 0 1 3.041-3.041h47.471a3.05 3.05 0 0 1 3.041 3.041Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 879",
    d: "M31.001 112.988a6.507 6.507 0 1 0-6.5-6.515 6.51 6.51 0 0 0 6.5 6.515Zm0-8.88a2.365 2.365 0 1 1-2.364 2.364 2.364 2.364 0 0 1 2.364-2.364Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 859",
    d: "M31.268 72.593a3.389 3.389 0 0 0 3.379-3.379h-6.758a3.389 3.389 0 0 0 3.379 3.379Zm10.98-19.427a10.871 10.871 0 0 0-8.446-10.643V41.34a2.534 2.534 0 0 0-5.068 0v1.183a9.769 9.769 0 0 0-2.365.845l15.88 15.88Zm-.507 14.36 3.379 3.38 2.2-2.2-28.212-28.211-2.2 2.2 4.9 4.9a10.633 10.633 0 0 0-1.52 5.575v9.291l-3.38 3.375v1.689Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopAlarmBipTelephonePortrait);
export default __webpack_public_path__ + "static/media/stop-alarm-bip-telephone-portrait.daa4c2b0d52df251118b252f038d9489.svg";
export { ForwardRef as ReactComponent };